/**
 * Data/canonicals.js — Canonical column schema for the unified data model.
 * Defines the standardized column names, data types, and mandatory/optional
 * flags that user-uploaded data must be mapped to during the ingestion flow.
 * Mandatory fields are required for analysis; optional fields enrich the dataset.
 */
export const canonicals = [
  { header: "Supplier_ID", datatype: "str", isMandatory: true },
  { header: "Buyer_ID", datatype: "str", isMandatory: true },
  { header: "Clearing_Document_ID", datatype: "str", isMandatory: true },
  { header: "Document_Number", datatype: "str", isMandatory: true },
  { header: "Document_Currency", datatype: "str", isMandatory: true },
  { header: "Amount_Document_Currency", datatype: "float", isMandatory: true },
  { header: "Issue_Date", datatype: "date", isMandatory: true },
  { header: "Due_Date", datatype: "date", isMandatory: true },
  { header: "Close_Date", datatype: "date", isMandatory: true },
  { header: "Document_Type", datatype: "str", isMandatory: true },
  { header: "Local_Currency", datatype: "str", isMandatory: false },
  { header: "Amount_Local_Currency", datatype: "float", isMandatory: false },
  { header: "Parent_Reporting_Currency", datatype: "str", isMandatory: false },
  { header: "Amount_Parent_Reporting_Currency", datatype: "float", isMandatory: false },
  { header: "Document_Type_Description", datatype: "str", isMandatory: false },
  { header: "Document_Accounting_Period", datatype: "str", isMandatory: false },
  { header: "Terms", datatype: "str", isMandatory: false },
  { header: "Sales_Tax_Amount", datatype: "float", isMandatory: false },
  { header: "Buyer_Name", datatype: "str", isMandatory: false },
  { header: "Buyer_Country", datatype: "str", isMandatory: false },
  { header: "Supplier_Name", datatype: "str", isMandatory: false },
  { header: "Supplier_Country", datatype: "str", isMandatory: false },
  { header: "Buyer_Parent_Code", datatype: "str", isMandatory: false },
  { header: "Buyer_Child_Code", datatype: "str", isMandatory: false },
  { header: "Supplier_Parent_Code", datatype: "str", isMandatory: false },
  { header: "Supplier_Child_Code", datatype: "str", isMandatory: false },
  { header: "Buyer_Parent_Name", datatype: "str", isMandatory: false },
  { header: "Buyer_Child_Name", datatype: "str", isMandatory: false },
  { header: "Supplier_Parent_Name", datatype: "str", isMandatory: false },
  { header: "Supplier_Child_Name", datatype: "str", isMandatory: false },
  { header: "Buyer_Company_Registration_Number", datatype: "str", isMandatory: false },
  { header: "Buyer_Sales_Tax_Registration", datatype: "str", isMandatory: false },
  { header: "Supplier_Company_Registration_Number", datatype: "str", isMandatory: false },
  { header: "Supplier_Sales_Tax_Registration", datatype: "str", isMandatory: false },
  { header: "Other_Tax_Code", datatype: "str", isMandatory: false },
  { header: "Other_Account_ID", datatype: "str", isMandatory: false },
  { header: "Other_Account_Description", datatype: "str", isMandatory: false }
];
